import { Injectable } from "@angular/core";
import { ApiService } from "./api";
import { PointSerieListItem, PayoutConfigPointSeriesDto } from "model/points/PointSeriesListItem";
import { PointSeries } from "../model/point-series";

@Injectable()
export class PointSeriesService 
{
    constructor(private api: ApiService) {}

    async getActiveOrganizationPointSeries(organizationId: number, rodeoId: number) {
        const url = `${this.api.endpoints.pointSeries}/active?organizationId=${organizationId}&rodeoId=${rodeoId}`;
        return await this.api.getWithAuth<PointSerieListItem[]>(url);
    }

    async getRodeoPayoutConfigPointSeries(rodeoId: number) {
        const url = `${this.api.endpoints.payoutconfigpointseries}/rodeo/${rodeoId}`;
        return await this.api.getWithAuth<PayoutConfigPointSeriesDto[]>(url);
    }

    async addPayoutConfigPointSeries(payoutConfigPointSeriesDto: PayoutConfigPointSeriesDto) {
        const url = `${this.api.endpoints.payoutconfigpointseries}`;
        return await this.api.postWithAuth<PointSeries>(url, payoutConfigPointSeriesDto);
    }

    async deletePayoutConfigPointSeries(payoutconfigId: number, pointSeriesId: number) {
        const url = `${this.api.endpoints.payoutconfigpointseries}/payoutconfig/${payoutconfigId}/pointseries/${pointSeriesId}`;
        return await this.api.deleteWithAuth(url);
    }
}


// WEBPACK FOOTER //
// ./src/services/pointseries.service.ts